<template>
  <div class="verify">
    <b-card>
      <b-card-body class="text-center">
        <p>zanim przejdziesz dalej, zalecamy potwierdzenie adresu e-mail</p>
        <p>Potwierdź swój adres e-mail, klikając przesłany do Ciebie link</p>
        <form @submit.prevent="submit()">
          <button class="btn btn-primary">
            ponownie wyślij link potwierdzający
          </button>
        </form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {BCard,BCardBody} from "bootstrap-vue";

export default {
  name: 'Verify',
  methods: {
    submit() {
      // post to API to resend email confirmation link
      this.$http.get(`${this.$store.state.apiDomain}/api/email/resend`)
          .then(response => {
            this.$bvToast.toast(response.data.message,{title:'resend',variant: 'success'});
          })
          .catch(response => {
            this.$bvToast.toast(response.data, {
              title: 'resend',
              solid: true,
              variant: 'danger',
            });
          })
    }
  },
  components: {
    BCard,BCardBody,
  },
};
</script>
